<template>
  <div>
    <div class="container">
      <TextArea
        class="child"
        :textTitle="endpointName"
        :textLinesArray="endpointDesc"
      ></TextArea>
      <EndpointCard
      class="child"
      cardTitle="ENDPOINTS"
      :endpoints="endpoints"
      />
      <TextArea
        class="child"
        :textTitle="filteringTitle"
        :textLinesArray="filteringText"
      ></TextArea>
    </div>
    <div :ref="endpoints[0].ref" class="container">
      <Attribute
        class="child"
        :attributes="attributes"
        :endpoint="responseTitle"
      />
      <ResponseCard
        class="child"
        :response="response"
        :cardTitle="responseCodeTitle"
      />
    </div>
  </div>
</template>

<style scoped>
.postCard {
  max-height: 600px;
}

.container {
  display: flex;
  flex-flow: row wrap;
  padding-left: 10rem;
  padding-right: 10rem;
}

.child {
  min-width: 40%;
  max-width: 45%;
  flex-grow: 1;
  flex-shrink: 1;
}

@media screen and (max-width: 500px) {
  .container {
    flex-flow: column wrap;
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

@media screen and (max-width: 500px) {
  .child {
    max-width: 380px;
    min-width: 300px;
  }
}
</style>

<script>
import EndpointCard from "../../../components/content/EndpointCard.vue";
import Attribute from "../../../components/request/Attribute.vue";
import TextArea from "../../../components/content/TextArea.vue";
import ResponseCard from "../../../components/request/ResponseCard.vue";

export default {
  components: {
    EndpointCard,
    Attribute,
    TextArea,
    ResponseCard,
  },
  created() {
    this.$root.$on("scrollToEndpoint", (ref) => {
      var element = this.$refs[ref];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    });
  },
  computed: {
    endpointName() {
      return this.$t("creditorsv4.endpointTitle");
    },
    filteringTitle() {
      return this.$t("creditorsv4.filteringTitle");
    },
    filteringText() {
      return this.$t("creditorsv4.filteringText");
    },
    endpointDesc() {
      return this.$t("creditorsv4.endpointDesc");
    },
    endpoints() {
      return this.$t("creditorsv4.controllerEndpoints");
    },
    responseTitle() {
      return this.$t("creditorsv4.getTitle");
    },
    responseCodeTitle() {
      return this.$t("creditorsv4.responseCodeTitle");
    },
    response() {
      return this.$t("creditorsv4.getResponse");
    },
    attributes() {
      return this.$t("creditorsv4.getAttributes");
    }
  },
};
</script>